"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ImageState = _interopRequireDefault(require("../ImageState.js"));

var _Image = _interopRequireDefault(require("./Image.js"));

var _color = require("../color.js");

var _colorlike = require("../colorlike.js");

var _dom = require("../dom.js");

var _canvas = require("../render/canvas.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/style/RegularShape
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] First radius of a star. Ignored if radius is set.
 * @property {number} [radius2] Second radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the shape
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius`, `radius1` and `radius2`.
 */

/**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike} [strokeStyle] StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */

/**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */
var RegularShape =
/** @class */
function (_super) {
  __extends(RegularShape, _super);
  /**
   * @param {Options} options Options.
   */


  function RegularShape(options) {
    var _this = this;
    /**
     * @type {boolean}
     */


    var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
    _this = _super.call(this, {
      opacity: 1,
      rotateWithView: rotateWithView,
      rotation: options.rotation !== undefined ? options.rotation : 0,
      scale: options.scale !== undefined ? options.scale : 1,
      displacement: options.displacement !== undefined ? options.displacement : [0, 0]
    }) || this;
    /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */

    _this.canvas_ = undefined;
    /**
     * @private
     * @type {HTMLCanvasElement}
     */

    _this.hitDetectionCanvas_ = null;
    /**
     * @private
     * @type {import("./Fill.js").default}
     */

    _this.fill_ = options.fill !== undefined ? options.fill : null;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.origin_ = [0, 0];
    /**
     * @private
     * @type {number}
     */

    _this.points_ = options.points;
    /**
     * @protected
     * @type {number}
     */

    _this.radius_ = options.radius !== undefined ? options.radius : options.radius1;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.radius2_ = options.radius2;
    /**
     * @private
     * @type {number}
     */

    _this.angle_ = options.angle !== undefined ? options.angle : 0;
    /**
     * @private
     * @type {import("./Stroke.js").default}
     */

    _this.stroke_ = options.stroke !== undefined ? options.stroke : null;
    /**
     * @private
     * @type {import("../size.js").Size}
     */

    _this.size_ = null;
    /**
     * @private
     * @type {RenderOptions}
     */

    _this.renderOptions_ = null;

    _this.render();

    return _this;
  }
  /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   */


  RegularShape.prototype.clone = function () {
    var scale = this.getScale();
    var style = new RegularShape({
      fill: this.getFill() ? this.getFill().clone() : undefined,
      points: this.getPoints(),
      radius: this.getRadius(),
      radius2: this.getRadius2(),
      angle: this.getAngle(),
      stroke: this.getStroke() ? this.getStroke().clone() : undefined,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      scale: Array.isArray(scale) ? scale.slice() : scale,
      displacement: this.getDisplacement().slice()
    });
    style.setOpacity(this.getOpacity());
    return style;
  };
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */


  RegularShape.prototype.getAnchor = function () {
    var size = this.size_;

    if (!size) {
      return null;
    }

    var displacement = this.getDisplacement();
    return [size[0] / 2 - displacement[0], size[1] / 2 + displacement[1]];
  };
  /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */


  RegularShape.prototype.getAngle = function () {
    return this.angle_;
  };
  /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default} Fill style.
   * @api
   */


  RegularShape.prototype.getFill = function () {
    return this.fill_;
  };
  /**
   * @return {HTMLCanvasElement} Image element.
   */


  RegularShape.prototype.getHitDetectionImage = function () {
    if (!this.hitDetectionCanvas_) {
      this.createHitDetectionCanvas_(this.renderOptions_);
    }

    return this.hitDetectionCanvas_;
  };
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   */


  RegularShape.prototype.getImage = function (pixelRatio) {
    var image = this.canvas_[pixelRatio];

    if (!image) {
      var renderOptions = this.renderOptions_;
      var context = (0, _dom.createCanvasContext2D)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
      this.draw_(renderOptions, context, pixelRatio);
      image = context.canvas;
      this.canvas_[pixelRatio] = image;
    }

    return image;
  };
  /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */


  RegularShape.prototype.getPixelRatio = function (pixelRatio) {
    return pixelRatio;
  };
  /**
   * @return {import("../size.js").Size} Image size.
   */


  RegularShape.prototype.getImageSize = function () {
    return this.size_;
  };
  /**
   * @return {import("../ImageState.js").default} Image state.
   */


  RegularShape.prototype.getImageState = function () {
    return _ImageState["default"].LOADED;
  };
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */


  RegularShape.prototype.getOrigin = function () {
    return this.origin_;
  };
  /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */


  RegularShape.prototype.getPoints = function () {
    return this.points_;
  };
  /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */


  RegularShape.prototype.getRadius = function () {
    return this.radius_;
  };
  /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */


  RegularShape.prototype.getRadius2 = function () {
    return this.radius2_;
  };
  /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   */


  RegularShape.prototype.getSize = function () {
    return this.size_;
  };
  /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default} Stroke style.
   * @api
   */


  RegularShape.prototype.getStroke = function () {
    return this.stroke_;
  };
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */


  RegularShape.prototype.listenImageChange = function (listener) {};
  /**
   * Load not yet loaded URI.
   */


  RegularShape.prototype.load = function () {};
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */


  RegularShape.prototype.unlistenImageChange = function (listener) {};
  /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */


  RegularShape.prototype.calculateLineJoinSize_ = function (lineJoin, strokeWidth, miterLimit) {
    if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') {
      return strokeWidth;
    } // m  | ^
    // i  | |\                  .
    // t >|  #\
    // e  | |\ \              .
    // r      \s\
    //      |  \t\          .                 .
    //          \r\                      .   .
    //      |    \o\      .          .  . . .
    //          e \k\            .  .    . .
    //      |      \e\  .    .  .       . .
    //       d      \ \  .  .          . .
    //      | _ _a_ _\#  .            . .
    //   r1          / `             . .
    //      |                       . .
    //       b     /               . .
    //      |                     . .
    //           / r2            . .
    //      |                        .   .
    //         /                           .   .
    //      |α                                   .   .
    //       /                                         .   .
    //      ° center


    var r1 = this.radius_;
    var r2 = this.radius2_ === undefined ? r1 : this.radius2_;

    if (r1 < r2) {
      var tmp = r1;
      r1 = r2;
      r2 = tmp;
    }

    var points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
    var alpha = 2 * Math.PI / points;
    var a = r2 * Math.sin(alpha);
    var b = Math.sqrt(r2 * r2 - a * a);
    var d = r1 - b;
    var e = Math.sqrt(a * a + d * d);
    var miterRatio = e / a;

    if (lineJoin === 'miter' && miterRatio <= miterLimit) {
      return miterRatio * strokeWidth;
    } // Calculate the distnce from center to the stroke corner where
    // it was cut short because of the miter limit.
    //              l
    //        ----+---- <= distance from center to here is maxr
    //       /####|k ##\
    //      /#####^#####\
    //     /#### /+\# s #\
    //    /### h/+++\# t #\
    //   /### t/+++++\# r #\
    //  /### a/+++++++\# o #\
    // /### p/++ fill +\# k #\
    ///#### /+++++^+++++\# e #\
    //#####/+++++/+\+++++\#####\


    var k = strokeWidth / 2 / miterRatio;
    var l = strokeWidth / 2 * (d / e);
    var maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
    var bevelAdd = maxr - r1;

    if (this.radius2_ === undefined || lineJoin === 'bevel') {
      return bevelAdd * 2;
    } // If outer miter is over the miter limit the inner miter may reach through the
    // center and be longer than the bevel, same calculation as above but swap r1 / r2.


    var aa = r1 * Math.sin(alpha);
    var bb = Math.sqrt(r1 * r1 - aa * aa);
    var dd = r2 - bb;
    var ee = Math.sqrt(aa * aa + dd * dd);
    var innerMiterRatio = ee / aa;

    if (innerMiterRatio <= miterLimit) {
      var innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
      return 2 * Math.max(bevelAdd, innerLength);
    }

    return bevelAdd * 2;
  };
  /**
   * @return {RenderOptions}  The render options
   * @protected
   */


  RegularShape.prototype.createRenderOptions = function () {
    var lineJoin = _canvas.defaultLineJoin;
    var miterLimit = 0;
    var lineDash = null;
    var lineDashOffset = 0;
    var strokeStyle;
    var strokeWidth = 0;

    if (this.stroke_) {
      strokeStyle = this.stroke_.getColor();

      if (strokeStyle === null) {
        strokeStyle = _canvas.defaultStrokeStyle;
      }

      strokeStyle = (0, _colorlike.asColorLike)(strokeStyle);
      strokeWidth = this.stroke_.getWidth();

      if (strokeWidth === undefined) {
        strokeWidth = _canvas.defaultLineWidth;
      }

      lineDash = this.stroke_.getLineDash();
      lineDashOffset = this.stroke_.getLineDashOffset();
      lineJoin = this.stroke_.getLineJoin();

      if (lineJoin === undefined) {
        lineJoin = _canvas.defaultLineJoin;
      }

      miterLimit = this.stroke_.getMiterLimit();

      if (miterLimit === undefined) {
        miterLimit = _canvas.defaultMiterLimit;
      }
    }

    var add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
    var maxRadius = Math.max(this.radius_, this.radius2_ || 0);
    var size = Math.ceil(2 * maxRadius + add);
    return {
      strokeStyle: strokeStyle,
      strokeWidth: strokeWidth,
      size: size,
      lineDash: lineDash,
      lineDashOffset: lineDashOffset,
      lineJoin: lineJoin,
      miterLimit: miterLimit
    };
  };
  /**
   * @protected
   */


  RegularShape.prototype.render = function () {
    this.renderOptions_ = this.createRenderOptions();
    var size = this.renderOptions_.size;
    this.canvas_ = {};
    this.size_ = [size, size];
  };
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */


  RegularShape.prototype.draw_ = function (renderOptions, context, pixelRatio) {
    context.scale(pixelRatio, pixelRatio); // set origin to canvas center

    context.translate(renderOptions.size / 2, renderOptions.size / 2);
    this.createPath_(context);

    if (this.fill_) {
      var color = this.fill_.getColor();

      if (color === null) {
        color = _canvas.defaultFillStyle;
      }

      context.fillStyle = (0, _colorlike.asColorLike)(color);
      context.fill();
    }

    if (this.stroke_) {
      context.strokeStyle = renderOptions.strokeStyle;
      context.lineWidth = renderOptions.strokeWidth;

      if (context.setLineDash && renderOptions.lineDash) {
        context.setLineDash(renderOptions.lineDash);
        context.lineDashOffset = renderOptions.lineDashOffset;
      }

      context.lineJoin = renderOptions.lineJoin;
      context.miterLimit = renderOptions.miterLimit;
      context.stroke();
    }
  };
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   */


  RegularShape.prototype.createHitDetectionCanvas_ = function (renderOptions) {
    if (this.fill_) {
      var color = this.fill_.getColor(); // determine if fill is transparent (or pattern or gradient)

      var opacity = 0;

      if (typeof color === 'string') {
        color = (0, _color.asArray)(color);
      }

      if (color === null) {
        opacity = 1;
      } else if (Array.isArray(color)) {
        opacity = color.length === 4 ? color[3] : 1;
      }

      if (opacity === 0) {
        // if a transparent fill style is set, create an extra hit-detection image
        // with a default fill style
        var context = (0, _dom.createCanvasContext2D)(renderOptions.size, renderOptions.size);
        this.hitDetectionCanvas_ = context.canvas;
        this.drawHitDetectionCanvas_(renderOptions, context);
      }
    }

    if (!this.hitDetectionCanvas_) {
      this.hitDetectionCanvas_ = this.getImage(1);
    }
  };
  /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */


  RegularShape.prototype.createPath_ = function (context) {
    var points = this.points_;
    var radius = this.radius_;

    if (points === Infinity) {
      context.arc(0, 0, radius, 0, 2 * Math.PI);
    } else {
      var radius2 = this.radius2_ === undefined ? radius : this.radius2_;

      if (this.radius2_ !== undefined) {
        points *= 2;
      }

      var startAngle = this.angle_ - Math.PI / 2;
      var step = 2 * Math.PI / points;

      for (var i = 0; i < points; i++) {
        var angle0 = startAngle + i * step;
        var radiusC = i % 2 === 0 ? radius : radius2;
        context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
      }

      context.closePath();
    }
  };
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */


  RegularShape.prototype.drawHitDetectionCanvas_ = function (renderOptions, context) {
    // set origin to canvas center
    context.translate(renderOptions.size / 2, renderOptions.size / 2);
    this.createPath_(context);
    context.fillStyle = _canvas.defaultFillStyle;
    context.fill();

    if (this.stroke_) {
      context.strokeStyle = renderOptions.strokeStyle;
      context.lineWidth = renderOptions.strokeWidth;

      if (renderOptions.lineDash) {
        context.setLineDash(renderOptions.lineDash);
        context.lineDashOffset = renderOptions.lineDashOffset;
      }

      context.lineJoin = renderOptions.lineJoin;
      context.miterLimit = renderOptions.miterLimit;
      context.stroke();
    }
  };

  return RegularShape;
}(_Image["default"]);

var _default = RegularShape;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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